export const STATUS = {
  submitted: 'Submitted',
  draft: 'Draft',
};
